import { ChartTimeSeriesLineTheme } from '@hcs/design-system';
import { DateStr } from '@hcs/types';

import { CerberusStatsHpiChart } from '../../components/CerberusStatsHpiChart';
import { MACRO_INSIGHTS_FROM_DATE } from '../../constants/marketInsights.constants';
import { useMsaHpiTimeSeries } from '../../hooks/useMsaHpiTimeSeries';

const dataHcName = 'msa-hpi-chart';

interface MsaHpiChartProps {
  className?: string;
  msaId: string;
  fromDate?: DateStr;
  toDate?: DateStr;
  theme?: Partial<ChartTimeSeriesLineTheme>;
}
export const MsaHpiChart = ({
  msaId,
  className,
  fromDate = MACRO_INSIGHTS_FROM_DATE,
  toDate,
  theme,
}: MsaHpiChartProps) => {
  const { data, isLoading } = useMsaHpiTimeSeries({
    msaId,
    fromDate,
    toDate,
  });
  return (
    <CerberusStatsHpiChart
      dataHcName={dataHcName}
      className={className}
      data={data}
      theme={theme}
      isLoading={isLoading}
    />
  );
};
